// extracted by mini-css-extract-plugin
export default {"box":"index_box_spT5Z","footer":"index_footer_buDwQ"};